





































































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Route } from 'vue-router'
import { ExStore } from 'vuex'
import dayjs from 'dayjs'
import store from '@/store'
import BaseTab from './baseTab'
import { DateString } from '@/types/utils'
import { formatDispayDate } from '@/utils/datetime'
import { EventEmitter } from 'events'
import { DeleteConfirmResults } from '@/constants/utils'
import ky from 'ky'
import { isCordovaEnvironment } from '@/utils/cordova'

enum EventTypes {
  CONFIRM_DELETE
}

const TODAY = dayjs()

const handleChangeRounting = async (to: Route, next: () => void) => {
  const patientId = Number(to.params.patientId)
  const year = Number(to.query.year) || new Date().getFullYear()
  await store.dispatch('dispensation/fetch', { patientId, year })
  next()
}

@Component({
  components: {
    qrCode: () => import('@/components/common/qr/qr.vue'),
    qrDialog: () => import('@/components/common/qr/qrDialog.vue'),
    DeleteConfirmModal: () =>
      import('@/components/common/modals/AlertModal.vue')
  }
})
export default class DispensationTab extends mixins(BaseTab) {
  @Prop({ default: null, type: Number }) year!: number | null
  @Prop(Number) patientId!: number
  @Prop({ default: false }) onLoadShowQr!: boolean
  @Prop({ default: false }) defaultRegular!: boolean

  $store!: ExStore
  showQR = false
  regular = false
  showDeleteConfirmModal = false
  events = new EventEmitter()
  qrErrorMessage = ''

  get inCallWebView() {
    return this.$store.getters['videoCallRoom/inCallWebView']
  }

  get dispensations() {
    return this.$store.getters['dispensation/dispensations']
  }

  get ids() {
    return this.$store.getters['dispensation/sort']
  }

  get selectedYear() {
    return this.year || TODAY.year()
  }

  set selectedYear(year) {
    this.$router.push({
      name: 'DispensationTab',
      query: { year: String(year) }
    })
  }

  get yearOptions() {
    const start = 2018
    const end = TODAY.year()
    return [...new Array(end - start + 1)].map((_, i) => end - i)
  }

  created() {
    this.$postMessage.addEventListener('activateApp', () => {
      this.$store.dispatch('dispensation/fetch', {
        patientId: this.patientId
      })
    })
  }

  async mounted() {
    if (!this.onLoadShowQr) return
    await this.checkIsValidLogin()
    this.$store.dispatch('videoCallRoom/setInCallWebView')
    this.showQR = true
    this.regular = this.defaultRegular
  }

  async checkIsValidLogin() {
    try {
      await this.$api.user.fetch()
    } catch (e) {
      this.$router.replace({ name: 'PatientLogin' })
    }
  }

  formatDispayDate(dateString: DateString) {
    return formatDispayDate(dateString)
  }

  handleClickUploadButton() {
    this.launchQrReader()
  }

  async QRData($event: string) {
    try {
      await this.$api.dispensation.uploadQR({
        patientId: this.patientId,
        data: $event,
        regular: this.regular
      })
      await this.$store.dispatch('dispensation/fetch', {
        patientId: this.patientId
      })
      this.quitQrReader()
    } catch (e) {
      if (e instanceof ky.HTTPError) {
        if (e.response.status !== 400) {
          this.qrErrorMessage = '不正なQRコードです'
          return
        }
        const errors = await e.response.json()
        const errorList = Object.keys(errors).reduce(
          (list, key) => list.concat(errors[key]),
          [] as string[]
        )
        this.qrErrorMessage = errorList.join(', ')
        return
      } else {
        this.qrErrorMessage = '通信エラー'
      }
      console.error(e)
    }
  }

  async handleClickDeleteButton(dispensationId: number) {
    this.showDeleteConfirmModal = true
    const resust = await new Promise<DeleteConfirmResults>(resolve =>
      this.events.once(EventTypes.CONFIRM_DELETE, resolve)
    )
    this.showDeleteConfirmModal = false
    if (resust === DeleteConfirmResults.CANCEL) {
      return
    }

    await this.$store.dispatch('dispensation/delete', {
      patientId: this.patientId,
      dispensationId
    })
  }

  async beforeRouteEnter(to: Route, from: Route, next: () => void) {
    await handleChangeRounting(to, next)
  }

  async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    await handleChangeRounting(to, next)
  }

  handleDeleteConfirmOk() {
    this.events.emit(EventTypes.CONFIRM_DELETE, DeleteConfirmResults.OK)
  }

  handleDeleteConfirmCancel() {
    this.events.emit(EventTypes.CONFIRM_DELETE, DeleteConfirmResults.CANCEL)
  }

  launchQrReader() {
    if (!isCordovaEnvironment()) {
      this.showQR = true
      return
    }
    this.$postMessage.showDispensationQR(this.patientId, this.regular)
  }

  quitQrReader() {
    if (!this.inCallWebView) {
      this.showQR = false
      return
    }
    this.$router.replace({ name: 'Hangup' })
  }
}
